export const checkboxClassName = 'checkbox-selectall';
export const checkboxSpanClassName = 'checkbox-span-selectall';